import { Message } from 'semantic-ui-react';

function OutbiddenByTime() {
  return (
    <Message attached="bottom" color="yellow">
      <Message.List
        items={[
          '정상적으로 입찰되었지만, 같은 가격으로 입찰한 참여자가 있었습니다.',
          '같은 가격을 제시한 참여자가 있을 경우 먼저 제시한 사람이 우선권을 가집니다.',
          '입찰 회수에는 제한이 없으니 다시 한 번 도전해보세요.',
        ]}
      />
    </Message>
  );
}

export default OutbiddenByTime;
